module.exports = __webpack_public_path__ + "fa-solid-900.ffc89d3ea2e2c3ba2956.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.ttf
// module id = ./src/assets/webfonts/fa-solid-900.ttf
// module chunks = styles